import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import '../../../../assets/stylesheets/ClubSlide/MainClub.scss';
import {useSelector} from "react-redux";
import {getClubChipBalance, getGlobalAccountBalance} from "../../../../store/selectors";
import {requestExchangeSapphires} from "../../../../store/actionCreators/exchange";

const rate = 2.5;
const Chips = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const globalBalance = useSelector(getGlobalAccountBalance);
    const clubBalance = useSelector(getClubChipBalance);
    const [amount, setAmount] = useState(0);

    const makeExchange = () => {
        dispatch(requestExchangeSapphires({amount, changeTo: 'chip'}));
    };
    
    const handleChange = (e) => {
        if (!(/[0-9\/]+/).test(e.key)) {
            e.preventDefault();
        } else {
            setAmount(e.target.value)
        }
    }
    return (
        <div className={`exhangeDialogContent`}>
            <div className={`chips`}>
                <p className={`currentBalance`}>{t('exchange.currentBalance')}</p>
                <div className = {`balancecontainer`}>
                    <div className={`diamondBalance left`}>
                        <span className={`sapphireIcon left`}></span>
                        <span>{globalBalance.diamonds}</span>
                    </div>
                    <div className={`chipCount left`}>
                        <span className={`chipIcon left`}></span>
                        <span>{clubBalance}</span>
                    </div>
                </div>
                <p className={`currentExchange`}>{t('exchange.currentExchange')}</p>
                <div className = {`balancecontainer`}>
                    <div className={`diamondBalance right`}>
                        <span className={`sapphireIcon right`}></span>
                        <input defaultValue={amount} onKeyPress={e => handleChange(e)} type="number"/>
                    </div>
                    <div className={`arrowIcon arrowRight`}></div>
                    <div className={`chipCount right`}>
                        <span className={`chipIcon right`}></span>
                        <span>{amount/rate}</span>
                    </div>
                </div>
                <div className={`exchangeInfo`}>
                    <span>{t('exchange.sapphireExchange', {sapphires: 100, chips: 40})}</span>
                    <p>{t('exchange.minExchangeAmount')}: 100</p>
                </div>
                <div className={`dialogConfirmBox`}>
                    <button className={`primary`} onClick={makeExchange}>{t('exchange.convert')}</button>
                </div>
            </div>
        </div>
    );
};

export default Chips;
